module.exports = __webpack_public_path__ + "static/media/020.04da6f50.jpg";